import {shortenEnv} from "../../Const";

export enum SynergyFinderPipelineStatus {
    IN_PROGRESS = "In progress",
    FAILED = "Failed",
    COMPLETED = "Completed",
}

export const synergyFinderApiConsts = {
    API_NAME: "synergy-finder", // This name needs to be the same as the name of the API in the App.tsx file
}

export const SYNERGY_FINDER_BUCKET_NAME = shortenEnv + "-synergy-finder-excel-upload"

export enum SynergyFinderCalculationMethod {
    ZIP = "ZIP",
    HSA = "HSA",
    Bliss = "Bliss",
    Loewe = "Loewe"
}